module.exports = __webpack_public_path__ + "static/media/232.903e4995.png";